import { IonButton, IonCard, IonCardContent, IonIcon, IonText } from "@ionic/react";
import { alertCircleOutline, downloadOutline, giftOutline } from "ionicons/icons";

import SlideContent from "../../../components/slide-content/SlideContent";
import { Empty } from "../../../layouts/errors/Empty";
import { passToWebView } from "../../../library/Funcs";

import "./GiftDoc.css";

interface Props {
  docs: any;
}

const GiftDocs: React.FC<Props> = (props) => {
  return (
    <SlideContent class="gift-doc" type="segment">
      <IonCard>
        <Empty length={props.docs?.length} icon={alertCircleOutline} text="سندی وجود ندارد!">
          <IonCardContent>
            {props.docs?.map((element: any) => {
              return (
                <div className="gift-item">
                  <IonIcon icon={giftOutline} />
                  <div>
                    <IonText><strong>از طرف {element.donator}</strong></IonText>
                    <IonText>{element.mobile}</IonText>
                  </div>
                  <IonButton color="primary" onClick={() => passToWebView("sendPayment", element.link)}>
                      <IonIcon icon={downloadOutline}/>
                    </IonButton>
                </div>
              );
            })}
          </IonCardContent>
        </Empty>
      </IonCard>
    </SlideContent>
  );
};

export default GiftDocs;
